<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <router-link to="/admin/lessons/lesson_details" class="btn add">
              <i class="fas fa-plus ms-1"></i>
              إضافة درس جديد
            </router-link>

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>

            <!-- Filter -->
            <button
              class="btn me-2 add"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <i class="fas fa-filter ms-1"></i>
              فلتر
            </button>
            <div
              class="modal fade"
              tabindex="-1"
              id="filterModal"
              aria-labelledby="filterModalLabel"
              data-bs-backdrop="static"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <form @submit.prevent="filteredSelectData($event)">
                    <div class="modal-header">
                      <h5 class="modal-title">اعادة تصنيف</h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <!-- Add Categories Select -->
                      <div class="categories__select">
                        <div
                          class="categories__select__data"
                          v-show="this.categories.length > 0"
                        >
                          <div class="form-group">
                            <label>التصنيف</label>
                            <select
                              class="form-select form-control mt-2"
                              aria-label="Default select "
                              @change="onSelectMainCategory($event)"
                            >
                              <option selected value="">اختار التصنيف</option>
                              <option
                                v-for="category in this.Maincategories"
                                :key="category.category_id"
                                :value="category.title"
                              >
                                {{ category.title }}
                              </option>
                            </select>
                          </div>
                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subCategory"
                                @change="onSelectSubCategory($event)"
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>
                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-show="this.subSubSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subSubCategory"
                                @change="onSelectSubSubCategory($event)"
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSubSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>
                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subSubSubSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subSubSubCategory"
                                @change="onSelectSubSubSubCategory($event)"
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSubSubSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>
                        </div>
                        <div
                          v-show="this.categories.length == 0"
                          class="categories__select__noData pt-3"
                        >
                          <p>اختار التصنيف:</p>
                          <h6 class="text-center pb-3">
                            لا يوجد تصنيفات حتى الآن
                          </h6>
                        </div>
                      </div>
                      <!-- Add Categories Select -->
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn delete"
                        data-bs-dismiss="modal"
                        @click="removeFiltered()"
                      >
                        اعادة تعيين
                      </button>
                      <button type="submit" class="btn add">تنفيذ</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>

            <table v-show="this.lessons.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th class="fit text-center" scope="col">الرقم</th>
                  <th scope="col">عنوان الدرس</th>
                  <th scope="col">السعر</th>
                  <th scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(lesson, index) in this.lessons" :key="index">
                  <th class="text-center" scope="row">{{ index + 1 }}</th>

                  <td>{{ lesson.title }}</td>
                  <td>{{ lesson.price }}</td>
                  <td class="controls">
                    <router-link
                      class="btn view"
                      :to="{
                        name: 'view_lesson',
                        params: { index: index },
                      }"
                    >
                      <i class="fas fa-folder ms-1"></i>
                      عرض
                    </router-link>

                    <router-link
                      class="btn edit"
                      :to="{
                        name: 'edit_lesson',
                        params: { id: lesson.lesson_id },
                      }"
                    >
                      <i class="fas fa-edit"></i>
                      تعديل
                    </router-link>

                    <button
                      class="btn delete"
                      @click="this.deleteSelectedLesson(lesson)"
                    >
                      <i class="fas fa-trash-alt ms-2"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-show="
                (!this.isloading && !this.lessons) || this.lessons.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد دروس حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Swal
import Swal from "sweetalert2";
// Vuex
import { mapActions, mapGetters } from "vuex";
// Firebase Upload Component
// import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
// import { useToast, TYPE } from "vue-toastification";
// Delete from firebase Storage
// import { deleteFileFromUrl } from "@/firebase/firebase_storage";

export default {
  data() {
    return {
      isloading: false,
      firstLoad: "",
      currentView: "الدروس",
      isEmpty: false,
      lessons: [],
      lesson: {
        title: "",
        price: "",
        grade: "",
        term: "",
      },
      // Search
      searchValue: "",
      // filter
      // All Categories
      categories: [],
      // Get Categories has Main
      Maincategories: [],
      // Loop for Categories
      selectedCategory: null,
      selectedSubCategory: null,
      selectedSubSubCategory: null,
      selectedSubSubSubCategory: null,
      // Save Result loop Categories
      subSelect: [],
      subSubSelect: [],
      subSubSubSelect: [],
      // Fitler Array
      filter: [],
    };
  },
  components: {},
  methods: {
    // Call Vuex actions
    ...mapActions("lessonsModule", [
      "fetchLessons",
      "deleteLesson",
      "clearState",
    ]),
    //-----------------------------------------------
    // Sort
    sortByCreateDate() {
      this.lessons.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.lessons.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.lessons = this.getLessons.filter(
          (item) => item.title.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------------//
    // Get Categories
    ///// Get Main Category
    onSelectMainCategory($event) {
      let title = $event.target.value;
      this.selectedCategory = this.categories.filter(
        (item) => item.title === title
      )[0];
      // Reset Choose Sub Category
      this.subSelect = [];
      this.subSubSelect = [];
      this.subSubSubSelect = [];

      this.filter = [];

      // Choose Sub Category
      if (this.selectedCategory.sub_categories.length > 0) {
        this.subSelect.push(...this.selectedCategory.sub_categories);
      }
      this.filter.push(this.selectedCategory.category_id);

      document.getElementById("subCategory").value = 0;
    },
    ///// Get Sub Category
    onSelectSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubCategory = this.subSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSelect = [];
      this.subSubSubSelect = [];
      this.filter.splice(1, 3);
      if (this.selectedSubCategory.sub_categories.length > 0) {
        this.subSubSelect.push(...this.selectedSubCategory.sub_categories);
      }
      this.filter.push(this.selectedSubCategory.category_id);
      document.getElementById("subSubCategory").value = 0;
    },
    ///// Get Sub Sub Category
    onSelectSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubCategory = this.subSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSubSelect = [];

      this.filter.splice(2, 1);
      if (this.selectedSubSubCategory.sub_categories.length > 0) {
        this.subSubSubSelect.push(
          ...this.selectedSubSubCategory.sub_categories
        );
      }
      this.filter.push(this.selectedSubSubCategory.category_id);
      document.getElementById("subSubSubCategory").value = 0;
    },
    onSelectSubSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubSubCategory = this.subSubSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.filter.splice(3, 1);
      this.filter.push(this.selectedSubSubSubCategory.category_id);
      console.log(this.filter);
    },
    //-----------------------------------------------------//
    // Filter
    filteredSelectData(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      this.lessons = [];

      this.getLessons.forEach((lesson) => {
        if (this.filter.length == 1 && lesson.categories[0] == this.filter[0]) {
          this.lessons.push(lesson);
        } else if (
          this.filter.length == 2 &&
          lesson.categories[0] == this.filter[0] &&
          lesson.categories[1] == this.filter[1]
        ) {
          this.lessons.push(lesson);
        } else if (
          this.filter.length == 3 &&
          lesson.categories[0] == this.filter[0] &&
          lesson.categories[1] == this.filter[1] &&
          lesson.categories[2] == this.filter[2]
        ) {
          this.lessons.push(lesson);
        } else if (
          this.filter.length == 4 &&
          lesson.categories[0] == this.filter[0] &&
          lesson.categories[1] == this.filter[1] &&
          lesson.categories[2] == this.filter[2] &&
          lesson.categories[3] == this.filter[3]
        ) {
          this.lessons.push(lesson);
        }
        // if (lesson.categories[0] == this.filter[0]) {
        //   this.lessons.push(lesson);
        //   if (lesson.categories[1] == this.filter[1]) {
        //     this.lessons = [];
        //     this.lessons.push(lesson);
        //   } else {
        //     this.lessons = [];
        //   }
        // } else {
        //   this.lessons = [];
        // }
      });

      closeButton.click();
    },
    isEqual(a, b) {
      return a.join() == b.join();
    },

    removeFiltered() {
      this.lessons = this.getLessons;
      // this.filter = "";
      this.filter = [];
    },
    //-----------------------------------------------

    onSubmit() {
      console.log(this.subjects);
    },

    // 3- Delete Category
    async deleteSelectedLesson(lesson) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا التصنيف؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف التصنيف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteLesson(lesson.lesson_id);
          // deleteFileFromUrl(category.image);
        }
      });
    },
  },

  async created() {
    if (this.isFirstLoad) await this.fetchLessons();
    this.Maincategories = this.getCategories.filter(
      (item) => item.main_category === true
    );
    this.clearState();
  },
  computed: {
    ...mapGetters("lessonsModule", [
      "getLessons",
      "isLoading",
      "isFirstLoad",
      "getUpdatedLoad",
    ]),
    ...mapGetters("categoriesModule", ["getCategories"]),
  },
  mounted() {
    this.lessons = this.getLessons;
    this.firstLoad = this.isFirstLoad;
    this.isloading = this.isLoading;
    this.categories = this.getCategories;
  },
  watch: {
    getLessons() {
      this.lessons = this.getLessons;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
    getCategories() {
      this.categories = this.getCategories;
    },
  },
};
</script>